<template>
  <div class="HomePageSideBar" id="scroll">
    <div v-if="checkEligiblity">
           
      <UserProfile  :active_period="active_period"></UserProfile>
    </div>

    <div>
      <div class="filter-toggle-btns" :class="[
        active_link == 'TOP_PERFORMERS' ? 'active-filter-toggle-btns' : '',
      ]" @click="showFilters('TOP_PERFORMERS')">
        <img src="../assets/images/asset4.png" style="height: 18px; margin-right: 10px;" />
        StockAnts Performers
        <i v-if="active_filter_tab1" class="el-icon-arrow-down"></i>
        <i v-else class="el-icon-arrow-right"></i>
      </div>

      <div class="filter-section bottom-margin-15" v-if="active_filter_tab1">
        <!-- filters for filter tab 1 -->
        <div class="filter-option" style="padding-bottom: 50px;">
          <div>
            <div class="filter-section-title">
              <div>
                <span class="border-bottom relative">Filters</span>
              </div>
              <span class="input-label-gray cursor-pointer" @click="resetFilter()">reset all</span>
            </div>

            <div v-for="(filter, index) in filter_list" :key="index">
              <div class="filter-toggle-content" :class="{
                'active-menu-bgColor': active_index_title == filter.title,
              }">
                <div class="filter-title" @click="showFiltersSubMenues(filter.title, filter)">
                  {{ filter.title }}
                  <i v-if="active_index_title == filter.title" class="el-icon-minus"></i>
                  <i v-else class="el-icon-plus"></i>
                </div>

                <div v-if="active_index_title == filter.title">
                  <div v-if="filter.title == 'Market cap' ||
                    filter.title == 'Reco type'
                    ">
                    <div v-for="(filter, index1) in filter.filter" :key="index1">
                      <el-checkbox-group v-model="checked_filters" @change="applyFilter()">
                        <el-checkbox class="filter-tab" :label="filter"></el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>

                  <!-- search stock section -->
                  <div v-if="filter.title == 'Search stock'">
                    <div class="flex top-margin-10">
                      <el-select v-model="search_stock" filterable remote reserve-keyword
                        placeholder="Search Company E.g. Infosys" class="custom-seach-input" size="small" clearable
                        :loading="is_search_stock_loading" :remote-method="searchStockList"
                        @change="handleStock(search_stock)">
                        <el-option v-for="stock in stock_list" :key="stock.id" :label="stock.name" :value="stock.id">
                          <span class="searched-stock-title">{{
                            stock.name
                          }}</span>
                          &nbsp;
                          <span class="input-label-gray" v-if="stock.symbol">({{ stock.symbol }})</span>
                        </el-option>
                      </el-select>
                    </div>
                  </div>

                  <!-- market expert dropdown section -->
                  <div v-if="filter.title == 'Market Participants'">
                    <div class="flex top-margin-10">
                      <el-select v-model="search_expert" filterable remote reserve-keyword
                        placeholder="Search Expert E.g. Motilal Os" class="custom-seach-input" size="small" clearable
                        :loading="is_search_expert_loading" :remote-method="searchExpertList"
                        @change="handleExpert(search_expert)">
                        <el-option v-for="expert in searched_expert_list" :key="expert.id" :label="expert.name"
                          :value="expert.id">
                        </el-option>
                      </el-select>
                    </div>

                    <div v-if="filter.experts">
                      <div v-for="(expert, index1) in filter.experts" :key="index1">
                        <div>
                          <div class="
                              top-margin-10
                              label-xss-black
                              font-weight-600
                              cursor-pointer
                              flex-space-between
                              capitalize
                            " @click="showSubMarketExperts(expert, index, index1)">
                            {{ expert.profession }}
                            <i v-if="expert.toggled" class="el-icon-minus label-xss-black"></i>
                            <i v-else class="el-icon-plus label-xss-black"></i>
                          </div>
                          <div v-if="expert.toggled" style="
                              overflow-y: auto;
                              max-height: 150px;
                              overflow-x: hidden;
                            " id="scroll1">
                            <div v-for="(item, index2) in expert.data" :key="index2">
                              <el-checkbox-group v-model="checked_expert_filters" @change="selectExpert(expert, index2)">
                                <el-checkbox class="filter-tab" :label="item.id">{{ item.name }}</el-checkbox>
                              </el-checkbox-group>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="filter.title == 'Market Participants' && !filter.experts
                      ">
                      <div v-for="(filter, index1) in filter.filter" :key="index1">
                        <el-checkbox-group v-model="checked_experts_profession_filters"
                          @change="applyExpertProfessionFilter()">
                          <el-checkbox class="filter-tab" :label="filter"></el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>

                  <!-- sector dropdown section -->
                  <div v-if="filter.title == 'Sectors'">
                    <el-select class="top-margin-10 width-100" v-model="sector" size="small" collapse-tags clearable
                      filterable @change="selectSector(sector)" placeholder="Select Sector">
                      <el-option v-for="item in sector_list" :key="item.id" :label="item.name"
                        :value="item.name"></el-option>
                    </el-select>
                  </div>

                  <div v-if="filter.title == 'Rating'" class="top-margin-5">
                    <el-rate :allow-half="true" v-model="star_rating" @change="changeRating()">
                    </el-rate>
                  </div>

                  <!-- <div v-if="filter.title == 'Term'">
                    <el-radio-group v-model="term" @change="changeTerm()">
                      <el-radio class="filter-tab" label="Short term">Short term</el-radio>
                      <el-radio class="filter-tab" label="Long term">Long term</el-radio>
                    </el-radio-group>
                  </div> -->

                  <div v-if="filter.title == 'Target period'">
                    <el-select class="top-margin-10 width-100" v-model="target_period_type" size="small" filterable
                      placeholder="Select" @change="selecteTargetPeriod()">
                      <el-option v-for="item in target_period_type_list" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>

                    <div v-if="target_period_type == 'shortTerm'">
                      <div>
                        <el-checkbox class="filter-tab" v-model="week_check" @change="setActivePeriodBtn('Week')">
                          Week
                        </el-checkbox>
                      </div>

                      <div>
                        <el-checkbox class="filter-tab" v-model="month_check" @change="setActivePeriodBtn('Month')">
                          Month
                        </el-checkbox>
                      </div>
                    </div>

                    <div v-if="target_period_type == 'midTerm'">
                      <div>
                        <el-checkbox class="filter-tab" v-model="current_quarter" @change="setTargetPeriod('Quarter')">
                          Quarter
                        </el-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
var _ = require("lodash");
import { serverAddr } from "../networkConfig";
import { serverHostName } from "../networkConfig";
import { HelperNetworkCallBack } from "../mixins/Helper";
import Hexagon from "@/components/Hexagon.vue";
import UserProfile from "@/components/UserProfile.vue";
import { EventBus } from "../eventBus";

export default {
  name: "HomePageSideBar",

  components: {
    Hexagon,
    UserProfile,
  },

  mixins: [HelperNetworkCallBack],

  props: [
    "active_sub_menu",
    "filterList",
    "resetFilters",
    "default_active_filter",
    'active_period'
  ],

  data() {
    return {
      serverHostName: serverHostName,
      active_link: "TOP_PERFORMERS",
      active_filter_tab1: 1,
      active_index_title: this.default_active_filter,

      filter_obj: {
        filters: [],
        experts: [],
        company_list: [],
        profession: [],
        stocks: [],
        sector: "",
        rating: "",
        target_period: {},
        term: "",
      },

      term: "",

      checked_filters: [],
      checked_expert_filters: [],
      checked_experts_profession_filters: [],

      sector: "",
      sector_list: [],

      // for search expert
      search_expert: "",
      searched_expert_list: [],
      is_search_expert_loading: false,

      //for search stock
      search_stock: "",
      stock_list: [],
      is_search_stock_loading: false,

      target_period_type: "",
      target_period_type_list: [
        {
          label: "Intraday",
          value: "IntraDay",
        },
        {
          label: "Short Term",
          value: "shortTerm",
        },
        {
          label: "Mid Term",
          value: "midTerm",
        },
        {
          label: "Long Term",
          value: "longTerm",
        },
      ],

      week_check: false,
      month_check: false,
      quarter_check: false,
      current_quarter: false,

      start_week_year: "",
      end_week_year: "",
      start_week: "",
      end_week: "",

      start_month_year: "",
      end_month_year: "",
      start_month: "",
      end_month: "",

      start_quarter_year: "",
      end_quarter_year: "",
      start_quarter: "",
      end_quarter: "",

      star_rating: null,
    };
  },

  watch: {
    resetFilters(newValue, oldValue) {
      this.active_index_title = this.default_active_filter;
      this.checked_filters = [];
      this.checked_expert_filters = [];
      this.checked_experts_profession_filters = [];
      this.star_rating = null;

      this.term = "";

      this.sector = "";

      this.search_expert = "";

      this.search_stock = "";

      this.target_period_type = "";

      this.week_check = false;
      this.month_check = false;
      this.quarter_check = false;
      this.current_quarter = false;

      this.start_week_year = "";
      this.end_week_year = "";
      this.start_week = "";
      this.end_week = "";

      this.start_month_year = "";
      this.end_month_year = "";
      this.start_month = "";
      this.end_month = "";

      this.start_quarter_year = "";
      this.end_quarter_year = "";
      this.start_quarter = "";
      this.end_quarter = "";

      this.filter_obj = {
        filters: [],
        experts: [],
        company_list: [],
        profession: [],
        stocks: [],
        sector: "",
        term: "",
        rating: "",
        target_period: {},
      };

      this.getSectorList();

      // if page is top performers then called get called
      if (this.active_sub_menu == "TOP_EXPERTS") {
        this.getCategoryWiseExpertList();
      }
    },

    // active_period() {
    //   this.getSectorList();
    // },
  },

  mounted() {
    this.getSectorList();

    // if page is top performers then called get called
    if (this.active_sub_menu == "TOP_EXPERTS") {
      this.getCategoryWiseExpertList();
    }

    EventBus.$on("clearAllSelectedFilters", (event) => {
      this.resetFilter();
    });
  },

  methods: {
    setActiveLink(label) {
      if (label == "TOP_PERFORMERS") {
        this.active_link = label;
      } else if (label == "USER_RECORD") {
        this.active_link = label;
      } else {
        this.active_link = label;
      }
      this.$emit("set_active_link", label);
    },

    showFilters(label) {
      if (label == "TOP_PERFORMERS") {
        this.active_filter_tab1 = !this.active_filter_tab1;
      } else if (label == "MY_LEAGUE") {
        this.active_link = label;
      }
    },

    showFiltersSubMenues(title, filter) {
      // if filter is accessible for non paid users
      if (filter.filter_type != "Free") {
        // checked subscribed plan has access to this filter
        if (
          !Object.keys(this.subscribedPlanDetails).length ||
          this.subscribedPlanDetails.plan == "Lite"
        ) {
          this.$store.commit("commitSubscribPlanDialogVisibility", true);
          return;
        }
      }

      if (this.active_index_title == "") {
        this.active_index_title = title;
      } else if (this.active_index_title == title) {
        this.active_index_title = "";
      } else {
        this.active_index_title = title;
      }
    },

    showSubMarketExperts(expert, parentIndex, childIndex) {
      if (expert.toggled) {
        expert.toggled = false;
      } else {
        expert.toggled = true;
      }
    },

    selectExpert(expert, index) {
      if (expert.profession != "company") {
        if (this.filter_obj.experts.indexOf(expert.data[index].id) == -1) {
          this.filter_obj.experts.push(expert.data[index].id);
        } else {
          let i = this.filter_obj.experts.indexOf(expert.data[index].id);
          this.filter_obj.experts.splice(i, 1);
        }
      } else if (expert.profession == "company") {
        if (this.filter_obj.company_list.indexOf(expert.data[index].id) == -1) {
          this.filter_obj.company_list.push(expert.data[index].id);
        } else {
          let i = this.filter_obj.company_list.indexOf(expert.data[index].id);
          this.filter_obj.company_list.splice(i, 1);
        }
      }

      EventBus.$emit("emitSelectedFilters", this.filter_obj);
    },

    //api to get stocks by search stock string
    searchExpertList: _.debounce(function (query) {
      this.is_search_expert_loading = true; //enabled loader
      this.searched_expert_list = [];

      serverAddr
        .post("/stockants_pro/search-expert-dashboard/", {
          search: query,
          // duration: this.filter_obj.target_period.key ? [] : this.filter_obj.term == "Short term" ? ["Week", "Month", "Quarter"] : this.filter_obj.term == "Long term" ? ["Long_term"] : ["Week", "Month", "Quarter", "Long_term"],
          // target_period: this.filter_obj.target_period
        })
        .then((response) => {
          if (response.data.status) {
            this.searched_expert_list = response.data.data;
          } else {
            this.searched_expert_list = [];
          }

          this.is_search_expert_loading = false; //disabled loader
        })
        .catch(function (error) {
          console.log("error");
          this.is_search_expert_loading = false; //disabled loader
        });
    }, 350),

    //api to get stocks by search stock string
    searchStockList: _.debounce(function (query) {
      this.stock_list = [];
      this.is_search_stock_loading = true; //enabled loader

      serverAddr
        .get(`/performers/v1/stock/search_stock/?q=${query}`)
        .then((response) => {
          if (response.data.status) {
            this.stock_list = response.data.data;
          } else {
            this.stock_list = [];
          }

          this.is_search_stock_loading = false; //disabled loader
        })
        .catch(function (error) {
          console.log("error");
          this.is_search_stock_loading = false; //disabled loader
        });
    }, 350),

    //select stock
    handleStock(item) {
      if (item) {
        if (this.filter_obj.stocks.indexOf(item) == -1) {
          this.filter_obj.stocks.push(item); //checked if expert is already pushed
        }
      } else {
        this.filter_obj.stocks = []; //cleared previously selected stocks
      }

      EventBus.$emit("emitSelectedFilters", this.filter_obj); //emitted event after selecting stock
    },

    //select seached expert
    handleExpert(item) {
      if (item) {
        if (this.checked_expert_filters.indexOf(item) == -1) {
          this.checked_expert_filters.push(item); //checked if expert is already pushed
        }
        this.filter_obj.experts = this.checked_expert_filters;

        EventBus.$emit("emitSelectedFilters", this.filter_obj); //emitted event after selecting seached expert
      }
    },

    //get market experts list
    getCategoryWiseExpertList() {
      serverAddr
        .get("/stockants_pro/category-wise-expert/")
        .then((response) => {
          if (response.data.status) {
            response.data.data.forEach((element) => {
              this.$set(element, "toggled", false); //created toggled key to toggle expert list
            });
            this.filterList[0].experts = [];
            for (let index = 0; index < response.data.data.length; index++) {
              if (
                response.data.data[index].profession == "Financial Advisor" ||
                response.data.data[index].profession == "Analyst"
              ) {
                this.filterList[0].experts.push(response.data.data[index]);
              }
            }
          } else {
            this.filterList[0].experts = [];
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    //api to get sector list
    getSectorList() {
      serverAddr
        .post("stockants_pro/search-sector-dashboard/", {
          duration: this.filter_obj.target_period.key
            ? []
            : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
          target_period: this.filter_obj.target_period,
        })
        .then((response) => {
          if (response.data.status) {
            this.sector_list = response.data.data;
          } else {
            this.sector_list = [];
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectSector(sector) {
      this.filter_obj.sector = sector;
      EventBus.$emit("emitSelectedFilters", this.filter_obj);
    },

    applyFilter() {
      this.filter_obj.filters = this.checked_filters;
      EventBus.$emit("emitSelectedFilters", this.filter_obj);
    },

    applyExpertProfessionFilter() {
      this.filter_obj.profession = this.checked_experts_profession_filters;
      EventBus.$emit("emitSelectedFilters", this.filter_obj);
    },

    changeTerm() {
      // this.filter_obj.sector = "";
      // this.sector = "";   //cleared sector on term selction because sector gets changed on short term and long term basis
      this.filter_obj.term = this.term;

      // reset previously selected target period filters
      this.week_check = false;
      this.month_check = false;
      this.quarter_check = false;
      this.current_quarter = false;

      this.start_week_year = "";
      this.end_week_year = "";
      this.start_week = "";
      this.end_week = "";

      this.start_month_year = "";
      this.end_month_year = "";
      this.start_month = "";
      this.end_month = "";

      this.start_quarter_year = "";
      this.end_quarter_year = "";
      this.start_quarter = "";
      this.end_quarter = "";

      this.filter_obj.target_period = {};

      EventBus.$emit("emitSelectedFilters", this.filter_obj);
    },

    selecteTargetPeriod() {
      if (
        this.target_period_type == "IntraDay" ||
        this.target_period_type == "longTerm"
      ) {
        this.filter_obj.target_period.key =
          this.target_period_type == "longTerm"
            ? "Long_term"
            : this.target_period_type;
        EventBus.$emit("emitSelectedFilters", this.filter_obj); //to filter data by week, month, quarter only
      }

      this.week_check = false;
      this.month_check = false;
      this.quarter_check = false;
      this.current_quarter = false;
    },

    changeRating() {
      this.filter_obj.rating = this.star_rating;
      EventBus.$emit("emitSelectedFilters", this.filter_obj);
    },

    resetFilter() {
      // checked subscribed plan has access to this filter
      // if(!Object.keys(this.subscribedPlanDetails).length || this.subscribedPlanDetails.plan == "Lite"){
      //   this.$store.commit('commitSubscribPlanDialogVisibility', true);
      //   return;
      // }

      // clear all applied filters
      this.checked_filters = [];
      this.checked_expert_filters = [];
      this.checked_experts_profession_filters = [];
      this.star_rating = null;

      this.term = "";

      this.sector = "";

      this.search_expert = "";

      this.search_stock = "";

      this.target_period_type = "";

      this.week_check = false;
      this.month_check = false;
      this.quarter_check = false;
      this.current_quarter = false;

      this.start_week_year = "";
      this.end_week_year = "";
      this.start_week = "";
      this.end_week = "";

      this.start_month_year = "";
      this.end_month_year = "";
      this.start_month = "";
      this.end_month = "";

      this.start_quarter_year = "";
      this.end_quarter_year = "";
      this.start_quarter = "";
      this.end_quarter = "";

      this.filter_obj = {
        filters: [],
        experts: [],
        company_list: [],
        profession: [],
        stocks: [],
        sector: "",
        term: "",
        rating: "",
        target_period: {},
      };

      this.getSectorList(); //called sector list api

      // if page is top performers then called get called
      // if(this.active_sub_menu == 'TOP_EXPERTS'){
      //   this.getCategoryWiseExpertList();
      // }

      EventBus.$emit("emitSelectedFilters", this.filter_obj);
    },

    clearFields(title) {
      if (title == "Week") {
        this.start_week = "";
        this.end_week = "";
        this.end_week_year = "";
      } else if (title == "Month") {
        this.start_month = "";
        this.end_month = "";
        this.end_month_year = "";
      } else if (title == "Quarter" || title == "Long_term") {
        this.start_quarter = "";
        this.end_quarter = "";
        this.end_quarter_year = "";
      }

      if (this.term == "Short term") {
        this.filter_obj.target_period = {};
        this.filter_obj.target_period.key = title;
      } else if (this.term == "Long term") {
        delete this.filter_obj.target_period.key;
        this.filter_obj.target_period = {};
      } else {
        this.filter_obj.target_period = {};
        this.filter_obj.target_period.key = title;
      }

      EventBus.$emit("emitSelectedFilters", this.filter_obj);
    },

    setTargetPeriod(title) {
      if (title == "Week") {
        if (
          this.start_week_year != "" &&
          this.end_week_year != "" &&
          this.start_week != "" &&
          this.end_week != ""
        ) {
          this.filter_obj.target_period.from_year = this.start_week_year;
          this.filter_obj.target_period.to_year = this.end_week_year;
          this.filter_obj.target_period.start_month = this.start_week;
          this.filter_obj.target_period.end_month = this.end_week;

          this.filter_obj.target_period.key = title;

          EventBus.$emit("emitSelectedFilters", this.filter_obj);
        }
      } else if (title == "Month") {
        if (
          this.start_month_year != "" &&
          this.end_month_year != "" &&
          this.start_month != "" &&
          this.end_month != ""
        ) {
          this.filter_obj.target_period.from_year = this.start_month_year;
          this.filter_obj.target_period.to_year = this.end_month_year;
          this.filter_obj.target_period.start_month = this.start_month;
          this.filter_obj.target_period.end_month = this.end_month;

          this.filter_obj.target_period.key = title;

          EventBus.$emit("emitSelectedFilters", this.filter_obj);
        }
      } else if (title == "Quarter") {
        this.current_quarter = true;
        this.filter_obj.target_period.key = title;

        EventBus.$emit("emitSelectedFilters", this.filter_obj);
      }
    },

    getCurrentQuarter(title) {
      var duration_title = "";
      if (title == "Current Quarter" || title == "Next Quarter") {
        duration_title = "Quarter";
      }
      this.filter_obj.target_period.key = duration_title;
      var d = new Date();
      // +4  is used for make financial quarter
      var current_quarter = Math.floor(d.getMonth() / 3) + 4;
      current_quarter =
        current_quarter > 4 ? current_quarter - 4 : current_quarter;
      var next_quarter = current_quarter + 1;
      next_quarter = next_quarter > 4 ? next_quarter - 4 : next_quarter;

      var selected_quarter =
        title == "Next Quarter" ? next_quarter : current_quarter;
      // var month = d.getMonth();
      // get year
      let year = d.getFullYear();

      this.start_quarter = selected_quarter;
      this.end_quarter = selected_quarter;

      if (title == "Next Quarter") {
        if (selected_quarter == 4) {
          this.start_quarter_year = year + 1;
          this.end_quarter_year = year + 1;
        } else {
          this.start_quarter_year = year;
          this.end_quarter_year = year;
        }

        this.next_quarter = true;
        this.current_quarter = false;
      } else {
        this.current_quarter = true;
        this.next_quarter = false;

        this.start_quarter_year = year;
        this.end_quarter_year = year;
      }

      this.filter_obj.target_period.from_year = this.start_quarter_year;
      this.filter_obj.target_period.to_year = this.end_quarter_year;
      this.filter_obj.target_period.start_month = this.start_quarter;
      this.filter_obj.target_period.end_month = this.end_quarter;

      EventBus.$emit("emitSelectedFilters", this.filter_obj);
    },

    setActivePeriodBtn: function (title) {
      if (title == "Week") {
        this.week_check = true;
        this.month_check = false;
        this.quarter_check = false;
      } else if (title == "Month") {
        this.month_check = true;
        this.week_check = false;
        this.quarter_check = false;
      } else if (title == "Quarter") {
        this.quarter_check = true;
        this.month_check = false;
        this.week_check = false;
      } else {
        this.week_check = false;
        this.month_check = false;
        this.quarter_check = false;
      }

      this.start_week = "";
      this.end_week = "";
      this.start_week_year = "";
      this.end_week_year = "";

      this.start_month = "";
      this.end_month = "";
      this.start_month_year = "";
      this.end_month_year = "";

      this.start_quarter_year = "";
      this.end_quarter_year = "";
      this.start_quarter = "";
      this.end_quarter = "";

      // this.filter_obj.experts = [];  //reset selected experts after selecting target period
      // this.filter_obj.company_list = [];  //reset selected compnay id list after selecting target period
      // this.filter_obj.stocks = [];  //reset selected stocks after selecting target period

      this.filter_obj.target_period = {};

      this.filter_obj.target_period.key = title;

      EventBus.$emit("emitSelectedFilters", this.filter_obj); //to filter data by week, month, quarter only
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },

  computed: {
    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },

    // return filter list
    filter_list() {
      return this.filterList;
    },

    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem("plan_details"));
    },
    // return user role from local storage.
    roles() {
      var roles = JSON.parse(localStorage.getItem("roles"));
      return roles[0];
    },

    // show profile card for retail investor if has_recommendation is tru
    checkEligiblity() {
      // this.userProfile.has_recommendation = true;
      if (this.userProfile.has_recommendation == undefined) {
        this.userProfile.has_recommendation = false;
      }
      if (
        this.userProfile &&
        this.userProfile.profession == "Retail Investor" &&
        this.userProfile.has_recommendation == false
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.HomePageSideBar {
  width: 265px;
  -webkit-box-shadow: 10px 0 10px -5px #d3d3d3;
  box-shadow: 10px 0 10px -5px #d3d3d3;
  position: fixed;
  height: 100%;
  overflow: auto;
  background-color: $filter-section-background-color;
  z-index: 3;
  padding-top: 30px;
}

.HomePageSideBar .filter-toggle-btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  background-color: #fff;
  color: #000;
  border-radius: 6px;
  margin: 0 auto 15px auto;
  padding: 12px;
  width: 70%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;

  i {
    font-size: 15px;
  }
}

.HomePageSideBar .active-filter-toggle-btns {
  background-color: $secondary-theme-color;
  color: #fff;
  font-weight: 500;
  cursor: pointer;

  i {
    font-size: 15px;
  }
}

// filter section css
.HomePageSideBar .filter-section {
  background-color: #f7f8fc;
  min-height: 530px;
}

.HomePageSideBar .filter-section-title {
  display: flex;
  justify-content: space-around;
  font-weight: 500;
  padding: 25px 0;
}

.HomePageSideBar .filter-header {
  padding-top: 20px;

  div {
    text-align: center;
    border-radius: 20px;
    border: 1px solid #000;
    font-size: 0.8rem;
    font-weight: 600;
    color: #000;
    padding: 5px 20px;
    width: fit-content;
    margin: 0 auto;
  }
}

.HomePageSideBar .border-bottom:after {
  position: absolute;
  bottom: -30px;
  left: 13px;
  width: 22px;
  height: 2px;
  margin-bottom: 25px;
  content: "";
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background-color: $primary-theme-color;
}

.filter-toggle-content {
  padding: 15px 20px;
  border-bottom: 1px solid #ddd;
}

.HomePageSideBar .filter-title {
  font-size: 0.8rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  .el-icon-plus,
  .el-icon-minus {
    font-size: 0.5rem;
    font-weight: 600;
  }
}

.filter-tab {
  display: block;
  margin-top: 10px;
}

.HomePageSideBar .active-menu-bgColor {
  background: $filter-section-background-color;
}

// filters input type css start
.HomePageSideBar .el-input--small .el-input__inner {
  border-radius: 25px !important;
  background: transparent !important;
  border-color: #797979 !important;
  color: #797979;
}

.HomePageSideBar .el-radio__label {
  color: black;
  font-size: 0.8rem;
  font-weight: 400;
}

.HomePageSideBar .el-input__inner::placeholder {
  color: #89898a;
}

.HomePageSideBar .el-select .el-input .el-select__caret {
  /* Internet Explorer */
  color: #89898a;
}

.HomePageSideBar .el-checkbox__inner {
  background-color: #dcdfe6;
}

.HomePageSideBar .el-checkbox__label {
  text-transform: capitalize;
  font-size: 13px;
  color: #000;
  font-weight: 400;
}

.HomePageSideBar .range-dropdown {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.HomePageSideBar .range-dropdown small {
  width: 30px;
  text-align: right;
  margin-right: 10px;
}

.HomePageSideBar .range-dropdown .el-input--mini .el-input__inner {
  border-radius: 5px !important;
  max-width: 95px;
  border-color: #797979;
  background: transparent;
}
</style>
<style>
.HomePageSideBar .rating-wrapper .el-rate__icon {
  margin-right: 2px !important;
}

.HomePageSideBar .el-checkbox__label {
  display: inline-block;
  padding-left: 10px;
  line-height: 19px;
  font-size: 12px;
  color: #000;
}

/* scroll bar css start */
#scroll::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

#scroll::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

#scroll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: lightgrey;
}

#scroll1::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

#scroll1::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

#scroll1::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: lightgrey;
}

.HomePageSideBar .filter-section .el-rate__icon {
  font-size: 18px !important;
  margin: 0 5px;
}
</style>
